import { render } from "./SceneComponentRenderer.vue?vue&type=template&id=a9cf9e2c"
import script from "./SceneComponentRenderer.vue?vue&type=script&lang=js"
export * from "./SceneComponentRenderer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\agent-2\\_work\\118\\s\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__